var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.48323 3.92758H2.22339C1.97772 3.92758 1.7793 4.12601 1.7793 4.37168V13.7764C1.7793 14.0221 1.97772 14.2205 2.22339 14.2205H5.48323C5.7289 14.2205 5.92733 14.0221 5.92733 13.7764V4.37168C5.92733 4.12601 5.7289 3.92758 5.48323 3.92758ZM5.03914 13.3323H2.66749V4.81577H5.03914V13.3323Z",
    fill: "#F3223C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 20937"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.715 2.14803H13.9024V0.444094C13.9024 0.198425 13.7039 0 13.4583 0H7.51181C7.26614 0 7.06772 0.198425 7.06772 0.444094V2.14803H1.28504C0.576378 2.14803 0 2.72441 0 3.43307V14.715C0 15.4236 0.576378 16 1.28504 16H14.7181C15.4268 16 16.0032 15.4236 16.0032 14.715V3.43307C16 2.72441 15.4236 2.14803 14.715 2.14803ZM7.95591 0.888189H13.011V4.01575H7.95591V0.888189ZM15.1118 14.715C15.1118 14.9323 14.9354 15.1087 14.7181 15.1087H1.28504C1.06772 15.1087 0.891339 14.9323 0.891339 14.715V3.43307C0.891339 3.21575 1.06772 3.03937 1.28504 3.03937H7.06772V4.0189H6.96693C6.72126 4.0189 6.52284 4.21732 6.52284 4.46299C6.52284 4.70866 6.72126 4.90709 6.96693 4.90709H14.0063C14.252 4.90709 14.4504 4.70866 14.4504 4.46299C14.4504 4.21732 14.252 4.0189 14.0063 4.0189H13.9055V3.03937H14.7181C14.9354 3.03937 15.1118 3.21575 15.1118 3.43307V14.715Z",
    fill: "#F3223C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.4584 5.79529H7.51197C7.2663 5.79529 7.06787 5.99371 7.06787 6.23938V8.32127C7.06787 8.56694 7.2663 8.76537 7.51197 8.76537H13.4584C13.7041 8.76537 13.9025 8.56694 13.9025 8.32127V6.23938C13.9025 5.99371 13.7041 5.79529 13.4584 5.79529ZM7.95606 7.87718V6.68348H13.0112V7.87718H7.95606Z",
    fill: "#F3223C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.13223 9.65668H7.80152C7.55585 9.65668 7.35742 9.8551 7.35742 10.1008C7.35742 10.3464 7.55585 10.5449 7.80152 10.5449H8.13223C8.37789 10.5449 8.57632 10.3464 8.57632 10.1008C8.57632 9.8551 8.37789 9.65668 8.13223 9.65668Z",
    fill: "#F3223C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.81094 9.65668H9.48023C9.23456 9.65668 9.03613 9.8551 9.03613 10.1008C9.03613 10.3464 9.23456 10.5449 9.48023 10.5449H9.81094C10.0566 10.5449 10.255 10.3464 10.255 10.1008C10.255 9.8551 10.0566 9.65668 9.81094 9.65668Z",
    fill: "#F3223C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.4896 9.65668H11.1589C10.9133 9.65668 10.7148 9.8551 10.7148 10.1008C10.7148 10.3464 10.9133 10.5449 11.1589 10.5449H11.4896C11.7353 10.5449 11.9337 10.3464 11.9337 10.1008C11.9337 9.8551 11.7353 9.65668 11.4896 9.65668Z",
    fill: "#F3223C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.1684 9.65668H12.8376C12.592 9.65668 12.3936 9.8551 12.3936 10.1008C12.3936 10.3464 12.592 10.5449 12.8376 10.5449H13.1684C13.414 10.5449 13.6125 10.3464 13.6125 10.1008C13.6125 9.8551 13.414 9.65668 13.1684 9.65668Z",
    fill: "#F3223C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M8.13223 11.4331H7.80152C7.55585 11.4331 7.35742 11.6315 7.35742 11.8772C7.35742 12.1228 7.55585 12.3213 7.80152 12.3213H8.13223C8.37789 12.3213 8.57632 12.1228 8.57632 11.8772C8.57632 11.6315 8.37789 11.4331 8.13223 11.4331Z",
    fill: "#F3223C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M9.81094 11.4331H9.48023C9.23456 11.4331 9.03613 11.6315 9.03613 11.8772C9.03613 12.1228 9.23456 12.3213 9.48023 12.3213H9.81094C10.0566 12.3213 10.255 12.1228 10.255 11.8772C10.255 11.6315 10.0566 11.4331 9.81094 11.4331Z",
    fill: "#F3223C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M11.4896 11.4331H11.1589C10.9133 11.4331 10.7148 11.6315 10.7148 11.8772C10.7148 12.1228 10.9133 12.3213 11.1589 12.3213H11.4896C11.7353 12.3213 11.9337 12.1228 11.9337 11.8772C11.9337 11.6315 11.7353 11.4331 11.4896 11.4331Z",
    fill: "#F3223C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M13.1684 11.4331H12.8376C12.592 11.4331 12.3936 11.6315 12.3936 11.8772C12.3936 12.1228 12.592 12.3213 12.8376 12.3213H13.1684C13.414 12.3213 13.6125 12.1228 13.6125 11.8772C13.6125 11.6315 13.414 11.4331 13.1684 11.4331Z",
    fill: "#F3223C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M8.13223 13.2094H7.80152C7.55585 13.2094 7.35742 13.4079 7.35742 13.6535C7.35742 13.8992 7.55585 14.0976 7.80152 14.0976H8.13223C8.37789 14.0976 8.57632 13.8992 8.57632 13.6535C8.57632 13.411 8.37789 13.2094 8.13223 13.2094Z",
    fill: "#F3223C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M9.81094 13.2094H9.48023C9.23456 13.2094 9.03613 13.4079 9.03613 13.6535C9.03613 13.8992 9.23456 14.0976 9.48023 14.0976H9.81094C10.0566 14.0976 10.255 13.8992 10.255 13.6535C10.255 13.411 10.0566 13.2094 9.81094 13.2094Z",
    fill: "#F3223C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M11.4896 13.2094H11.1589C10.9133 13.2094 10.7148 13.4079 10.7148 13.6535C10.7148 13.8992 10.9133 14.0976 11.1589 14.0976H11.4896C11.7353 14.0976 11.9337 13.8992 11.9337 13.6535C11.9337 13.411 11.7353 13.2094 11.4896 13.2094Z",
    fill: "#F3223C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M13.1684 13.2094H12.8376C12.592 13.2094 12.3936 13.4079 12.3936 13.6535C12.3936 13.8992 12.592 14.0976 12.8376 14.0976H13.1684C13.414 14.0976 13.6125 13.8992 13.6125 13.6535C13.6125 13.411 13.414 13.2094 13.1684 13.2094Z",
    fill: "#F3223C"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaxIcon);
export default __webpack_public_path__ + "static/media/faxIcon.b5cb926c932b5d60afa49fc557dcbf62.svg";
export { ForwardRef as ReactComponent };